const ContentText = ({ children, id }) => {
    return (
        <div className="pageContent" id={id}>
            {children}
        </div>
    );
};

export default ContentText;
